import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyListComponent } from '@app/shared/empty-list/empty-list.component';

@NgModule({
  declarations: [EmptyListComponent],
  imports: [CommonModule, TranslateModule],
  exports: [EmptyListComponent],
})
export class EmptyListModule {}
